(function () {
  function init(root) {
    if (root.dataset.lslInit) return;
    var grid = root.querySelector('.lsl-pgrid');
    var prev = root.querySelector('.lsl-pnav__prev');
    var next = root.querySelector('.lsl-pnav__next');
    if (!grid || !prev || !next) return;
    root.dataset.lslInit = 'true';

    function step() {
      var card = grid.querySelector('.lsl-card');
      return card ? card.getBoundingClientRect().width + 24 : 300;
    }

    function update() {
      prev.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -step() });
    });
    next.addEventListener('click', function () {
      grid.scrollBy({ left: step() });
    });
    grid.addEventListener('scroll', update, { passive: true });

    // Observer is tied to this grid; it is disconnected when the section unloads.
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(update);
      observer.observe(grid);
      root._lslObserver = observer;
    }
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lsl-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-lsl-carousel]').forEach(function (root) {
      if (root._lslObserver) root._lslObserver.disconnect();
    });
  });
})();
